module.exports = __webpack_public_path__ + "static/img/041002.4868d5ce.png";